import DOMPurify from "dompurify";
export const formatDescription = (html) => {
    if (!html) return "---";

    // Sanitize HTML by removing big headers and attributes that disrupt table styling
    const sanitized = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ["b", "i", "u", "strong", "em", "p", "span", "br"],
        ALLOWED_ATTR: [],
    });

    // Extract text content to measure word count
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitized;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    const words = textContent.trim().split(/\s+/).filter(Boolean);
    if (words.length > 100) {
        return words.slice(0, 100).join(" ") + "...";
    }

    return sanitized;
};